// extracted by mini-css-extract-plugin
export default {"header-container":"Product_header-container__357GD","flex":"Product_flex__AYHD7"};